<template>
  <div class="submit-order">
    <!-- tip -->
    <div class="tips list-block-margin" style="margin-top: 0">请您填写正确的联系方式和详细收货地址，以免影响您的正常收货。</div>
    <!-- address -->
    <div class="address-content list-block-margin">
      <div class="address-item">收件人：{{ mainOrder.userName }}</div>
      <div class="address-item">手机号：{{ mainOrder.mobileNo }}</div>
      <div class="address-item">收货地址：{{ mainOrder.address }}</div>
      <div class="address-item">邮政编码：{{ mainOrder.postCode || '-' }}</div>
      <van-button size="mini" color="#ff5757" class="edit" v-if="typeId == 4" @click="editAddress()">修改</van-button>
    </div>
    <!-- 商品列表 -->
    <van-cell-group class="goods-info list-block-margin">
      <van-cell title="单元格" value="内容">
        <template #title>
          <van-image :src="mainOrder.goodImage">
            <!-- 图标加载失败 -->
            <template #error>
              <van-icon name="photo-o" />
            </template>
          </van-image>
        </template>
        <template #default>
          <p>
            商品名称 <span>{{ mainOrder.goodsName }}</span>
          </p>
          <p class="block">
            商品单价 <span v-html="mainOrder.price">周一至周五 ￥1.80 <br />周六、周日、法定节日 ￥0.60</span>
          </p>
        </template>
      </van-cell>
    </van-cell-group>
    <!-- 日期列表操作 零售 -->
    <template v-if="typeId == 4 && $store.state.newsKiosk.dateList.length">
      <van-cell value="购买日期及数量" class="list-block-margin" />
      <van-swipe-cell v-for="(item, index) in $store.state.newsKiosk.dateList" :key="index">
        <van-cell :border="false" :title="item.date" value="">
          <template>
            <van-stepper v-model="item.number" :min="$store.state.newsKiosk.dateList.length < 2 ? 1 : 0" :disable-plus="item.number >= item.stockNum" integer @change="changeNumber(item)" />
          </template>
        </van-cell>
        <template #right>
          <van-button square type="danger" text="删除" @click="deleDate(item)" />
        </template>
      </van-swipe-cell>
    </template>
    <!-- 购买数量 非零售 -->
    <van-cell v-if="typeId != 4" title="购买数量" value="购买数量" class="list-block-margin">
      <template>
        <van-stepper v-model="goodsNumber" :disabled="typeId === 1" />
      </template>
    </van-cell>
    <!-- 配送、发票等信息 -->
    <van-cell-group class="list-block-margin">
      <van-form ref="form" @submit="submitOrder">
        <van-cell title="配送方式" :value="getDelivertype" is-link @click="chooseDistributionMode" />
        <template v-if="typeId !== 1">
          <van-cell title="发票信息" :value="getInvoice" is-link @click="openInvoiceModal" />
        </template>
        <van-field
          v-model="formData.cardid"
          v-if="typeId === 1"
          name="cardid"
          label="报卡编号"
          placeholder="必填"
          :rules="[{ validator: valiDateCardId, message: '请输入报卡编号', trigger: 'onBlur' }]"
        />
        <van-field v-model="formData.requirement" rows="2" autosize label="订单备注" type="textarea" maxlength="10" placeholder="无" show-word-limit :rules="[{ validator: validateInput }]" />
      </van-form>
    </van-cell-group>
    <!-- 商品价格、快递费 列表  零售-->
    <van-cell-group class="price-list list-block-margin">
      <van-cell title="商品价格" value="2021-06-03 ￥14.40">
        <template v-if="typeId === 4">
          <div class="list-block-inset" v-for="date in $store.state.newsKiosk.dateList" :key="date.subOrderId">
            <p class="goods-price">
              <span>{{ date.date }}<strong style="color: #ff5757" v-if="moment(date.date).valueOf() > moment().valueOf()">预售</strong></span> ￥{{ date.price }}
            </p>
            <p class="count-price">￥{{ date.price }}x{{ date.number }}</p>
          </div>
        </template>
        <template v-else>
          {{ total.price }}
        </template>
      </van-cell>
      <van-cell :title="typeId !== 1 ? '快递费' : ''" value="不开发票">
        <template>
          <div class="list-block-inset">
            <p v-if="typeId === 4">￥{{ total.deliveryPrice }}</p>
            <p v-else>&nbsp;</p>
            <p class="total">
              共{{ total.count }}件 <span>总计 ￥{{ total.price }}</span>
            </p>
          </div>
        </template>
      </van-cell>
      <!-- 提示 -->
      <div class="notice" v-if="typeId !== 1">提交说明：商品一旦发货，不支持退款操作</div>
    </van-cell-group>
    <!-- 提交订单按钮 -->
    <van-button class="list-block-margin" type="primary" :loading="submitLoading" block loading-text="提交中" @click="checkUserSubscribe">提交订单</van-button>
    <!-- 取消订阅按钮 -->
    <van-button class="list-block-margin cancel-button" v-if="typeId === 4" block @click="cancelOrderRetailGoods">取消</van-button>
    <!-- 配送方式弹窗 -->
    <DistributionModal v-model="distributionInfo.show" :info="distributionInfo.info" @confirmInfo="getDisstributionInfo"></DistributionModal>
    <!-- 发票信息弹窗 -->
    <InvoiceModal v-model="invoiceModalInfo.show" :info="invoiceModalInfo.info" @confirmInfo="getInvoiceInfo"></InvoiceModal>
  </div>
</template>

<script>
  // 混入文件
  import { submitOrder } from '@/mixins/newsKiosk/submitOrder'
  import { Dialog } from 'vant'
  export default {
    mixins: [submitOrder],
    data() {
      return {
        delivertype: 1, //配送方式类型选择
        papertype: 0, //发票信息类型选择
        papertypeInfo: {}, //发票信息填写
        formData: {},
        mainOrder: {}, //商品信息
        dateList: [], //订约日期及数量
        typeId: 0, //区分零售非零售
        goodsId: 0, //商品id
        goodsNumber: 0, // 非零售的商品数量
        orderId: ''
      }
    },
    created() {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      /**
       * todo 统一塞值处理
       */
      const setInfo = (res) => {
        let { mainOrder, subOrders, goodsInfo, orderInfo } = res
        let { price, priceHoliday, countStep, freight, freightMore, typeId, id } = goodsInfo
        this.typeId = typeId
        this.goodsId = id
        this.delivertype = this.typeId === 1 ? 0 : 1
        this.mainOrder = {
          ...mainOrder,
          ...orderInfo,
          ...subOrders,
          goodImage: goodsInfo.picPath,
          price: priceHoliday && JSON.parse(priceHoliday) ? `周一至周五 ￥${price} <br />周六、周日、法定节假日 ￥${priceHoliday}` : `￥${price}`,
          countStep,
          freight,
          freightMore
        }
        this.$store.dispatch(
          'newsKiosk/updateActionDateList',
          subOrders.map((item) => ({ ...item, price: Number.parseFloat(item.price).toFixed(2), number: item.goodsNumber, disableMinus: false, date: item.saleDate.split(' ')[0] }))
        )
      }

      // 非零售
      let { typeId, goodsName, price, goodsId, goodsNumber, goodImage } = this.$route.query
      if (typeId && Number.parseInt(typeId) !== 4) {
        this.typeId = Number.parseInt(typeId)
        this.goodsId = Number.parseInt(goodsId)
        this.delivertype = this.goodsId === 314 ? 3 : this.typeId === 1 ? 0 : 1 //配送方式
        let { userName: username, phone: mobileno, postalCode, provinceName, cityName, countryName, address, nationalCode } = JSON.parse(window.localStorage.getItem('addressInfo')) || {}

        //商品信息
        this.mainOrder = {
          goodsName,
          price: `￥${price}`,
          goodImage,
          userName: username,
          mobileNo: mobileno,
          address: provinceName + ' ' + cityName + ' ' + countryName + ' ' + address,
          postCode: postalCode
        }
        this.goodsNumber = this.typeId === 1 ? 1 : goodsNumber || 1 //购买数量
        return
      }

      // 零售
      this.getRetailGoodsOrderInfo().then((res) => {
        setInfo(res)
      })
    },
    methods: {
      // 修改地址
      editAddress() {
        // 已发货
        if ((this.mainOrder.orderFlg === 4 && this.mainOrder.deliverTime) || this.mainOrder.orderFlg === 5) {
          Dialog.alert({
            title: '提示',
            message: '您的包裹在发货中，不可修改名址',
            confirmButtonText: '确定'
          })
          return
        }
        this.getWxConfig().then((res) => {
          let { userName, telNumber, postalCode, provinceName, cityName, countryName, detailInfo, nationalCode } = res
          this.mainOrder.userName = userName
          this.mainOrder.mobileNo = telNumber
          this.mainOrder.address = provinceName + ' ' + cityName + ' ' + countryName + ' ' + detailInfo
          this.mainOrder.postCode = postalCode

          let params = {
            orderId: this.$route.query.orderId,
            userName,
            mobileNo: telNumber,
            postCode: postalCode,
            provinceName,
            cityName,
            countryName,
            address: detailInfo
          }
          this.$api.goodList
            .updataRetailGoodsOrderInfo(params)
            .then((res) => {
              let { result } = res
              // this.$toast('修改成功')
            })
            .catch((err) => {
              this.$toast(err)
            })
        })
      },
      /**
       * todo 拉取微信配置信息接口
       * @param {url: 当前全部地址，包括参数}
       */
      getWxConfig() {
        let _this = this
        // 获取 userInfo 包括 用户信息 手机号 地址相关
        return new Promise((resolve, reject) => {
          // 配置微信
          const wxApi = (data) => {
            window.wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: ['checkJsApi', 'openAddress', 'editAddress']
            })
            window.wx.ready(function () {
              window.wx.openAddress({
                success: function (res) {
                  resolve(res)
                },
                cancel(errMsg) {
                  reject(errMsg)
                }
              })
            })

            window.wx.error(function (res) {
              _this.$toast(res.errMsg)
              reject(res.errMsg)
            })
          }

          // 如果是ios直接从本地读取注册信息
          if (/iPhone|mac|iPod|iPad|ios/gi.test(navigator.userAgent)) {
            let result = JSON.parse(window.sessionStorage.getItem('wxc'))
            wxApi(result)
          } else {
            // let {} = this.$route.query
            let url = ''
            Object.keys(this.$route.query).forEach((key) => {
              if (key !== 'goodsDesc') {
                url += `&${key}=${this.$route.query[key]}`
              }
            })
            // 安卓正常拉取微信配置信息
            this.$api.user.getWxConfig({ url: window.location.href }).then((res) => {
              let { result } = res
              if (JSON.stringify(result) !== '{}') {
                wxApi(result)
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .submit-order {
    .list-block-margin {
      margin-top: 10px;
    }
    // 重写cell布局 需求
    .van-cell__title,
    /deep/ .van-field__word-limit,
    /deep/ .van-field__label,
    .van-cell__value {
      color: #000;
    }
    .goods-info {
      .van-cell {
        align-items: flex-start;
        font-size: 3vw;
      }
      .van-cell__title {
        min-width: auto;
        flex: inherit;
        box-shadow: 0 0px 3px #ccc;
        text-align: center;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        /deep/ .van-image {
          width: 20vw;
          height: 20vw;
          .van-image__error,
          .van-image__loading {
            font-size: 3rem;
            background-color: transparent;
          }
        }
      }
      .van-cell__value {
        text-align: left;
        flex: 1.5;
        p {
          margin: 0;
          line-height: 2;
          display: flex;
          span {
            flex: 1;
            margin-left: 6px;
          }
        }
      }
    }
    .price-list {
      .van-cell__value {
        flex: 1.5;
        .list-block-inset {
          margin-bottom: 10px;
        }
        p {
          margin: 0;

          &.total {
            color: #000;
            span {
              font-size: 4vw;
              color: #000;
            }
          }
          &.count-price {
            color: #000;
          }
          &.goods-price {
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              flex: 1;
              text-align: left;
              strong {
                margin-left: 1rem;
                font-size: 0.5rem;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
    .notice {
      background: #fff4f4;
      color: #ff5757;
      padding: 10px;
      text-align: center;
      font-size: 3vw;
    }
    .van-button {
      width: 90%;
      margin: 1vh auto;
      font-size: 1rem;
      height: auto;
      line-height: 2.5;
      &.van-button--danger {
        width: 100%;
      }
      &.cancel-button {
        background-color: #aaa;
        color: #fff;
      }
    }
    .van-swipe-cell__right {
      .van-button {
        margin: 0;
        height: 100%;
      }
    }
    /deep/ .van-popup {
      h2 {
        padding: 0 4vw;
        font-size: 5vw;
      }
    }
    .address-content {
      background: #fff;
      padding: 0.8rem 1rem;
      background-image: url('../../../assets/images/address_bg.png');
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: bottom left;
      position: relative;
      .address-item {
        font-size: 14px;
        color: #040404;
        line-height: 1.8rem;
      }
      .edit {
        position: absolute;
        right: 1rem;
        top: 0.5rem;
      }
      .van-button {
        width: auto;
        font-size: 0.78rem;
        line-height: 1;
        height: auto;
        padding: 0.3rem 0.5rem;
      }
    }
    .tips {
      background: #fff;
      font-size: 14px;
      color: #fc852c;
      padding: 0.7rem 1.2rem;
    }
  }

  @media screen and (min-width: 768px) {
    .submit-order {
      .goods-info .van-cell {
        font-size: 26px;
      }

      .notice,
      .van-button,
      .van-cell {
        font-size: 16px !important;
      }

      /deep/ .van-popup {
        h2 {
          padding: 0 16px;
          font-size: 16px;
        }
        .van-button {
          margin-top: 30px;
        }
      }

      .price-list .van-cell__value p.total span {
        font-size: 18px;
      }
    }
  }
</style>
